import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { userIdentifierStruct } from "../user/userIdentifierStruct";

import { sessionIdentifierStruct } from "./sessionIdentifierStruct";

export const sessionResourceStruct = createResourceStruct({
  identifier: sessionIdentifierStruct,
  attributes: sup.object({}),
  relationships: sup.object({
    user: sup.object({
      data: userIdentifierStruct,
    }),
  }),
});
